module.exports = __webpack_public_path__ + "static/media/lsDirectNEW_Reverse.5ed6b0e3.png";